import './index.css'
import './tiptap.css' // styles for rich text editor

import('./bootstrap')
